/* app/js/src/components/common/numberInput/number-input.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.root-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.theme-white .input-container input {
  background-color: #ffffff;
}
.theme-white input[type=number]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.theme-white .button {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: solid 1px #7d8fa1;
  cursor: pointer;
  position: relative;
}
.theme-white .button i {
  color: #7d8fa1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 8px;
}
.theme-white input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.theme-white .input-container {
  position: relative;
  margin: 0 10px 0 10px;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.theme-white .input-container input {
  outline: none;
  border: 1px solid #e1e6eb;
  width: 100%;
  height: 28px;
  border-radius: 4px;
  background-color: white;
  text-align: center;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #232f3a;
}
.theme-white .input-container input.disabled {
  background-color: #eef2f6 !important;
}
.theme-white .input-container .sign {
  position: absolute;
  content: "%";
  top: 50%;
  transform: translate(0, -50%);
  left: 80%;
  font-size: 12px;
}
.theme-white .normal-input input[type=number] {
  width: 70px;
  height: 30px;
  line-height: 30px;
  margin: 0;
  padding: 0;
  border: 1px solid #e1e6eb;
}
.theme-white .normal-input input[type=number]::-webkit-textfield-decoration-container {
  padding-left: 5px;
}
.theme-white .normal-input input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: inner-spin-button;
  opacity: 0.6 !important;
  cursor: pointer;
  height: 30px;
  width: 20px;
  line-height: 30px;
  border: 1px solid;
  border-radius: 4px;
}
.theme-white .normal-input input[type=number] .sign {
  left: 40%;
}
.theme-white .inputFieldOverlay {
  background-color: red;
}
.theme-dark .input-container input {
  background-color: green;
}
.theme-dark .button {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: solid 1px #7d8fa1;
  cursor: pointer;
  position: relative;
}
.theme-dark .button i {
  color: #7d8fa1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 8px;
}
.theme-dark input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.theme-dark .input-container {
  position: relative;
  margin: 0 10px 0 10px;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.theme-dark .input-container input {
  outline: none;
  border: 1px solid #e1e6eb;
  width: 100%;
  height: 28px;
  border-radius: 4px;
  background-color: white;
  text-align: center;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #232f3a;
}
.theme-dark .input-container input.disabled {
  background-color: #eef2f6 !important;
}
.theme-dark .input-container .sign {
  position: absolute;
  content: "%";
  top: 50%;
  transform: translate(0, -50%);
  left: 80%;
  font-size: 12px;
}
.theme-dark .normal-input input[type=number] {
  width: 70px;
  height: 30px;
  line-height: 30px;
  margin: 0;
  padding: 0;
  background-color: black;
  border: 1px solid #4d5761;
  text-align: center;
}
.theme-dark .normal-input input[type=number]::-webkit-textfield-decoration-container {
  padding-left: 5px;
}
.theme-dark .normal-input input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: inner-spin-button;
  opacity: 0.6 !important;
  cursor: pointer;
  height: 30px;
  width: 20px;
  line-height: 30px;
  border: 1px solid;
  border-radius: 4px;
}
.theme-dark .normal-input input[type=number] .sign {
  left: 40%;
}
.theme-dark .inputFieldOverlay {
  background-color: red;
}
/*# sourceMappingURL=number-input.component.css.map */
